import { Box, Typography } from "@mui/material"
import type { FC } from "react"
import { useEffect } from "react"
import { useShallow } from "zustand/react/shallow"

import type { PriceChangeTier } from "@/graphql/codegen/graphql"
import { useUnitOfMeasurementsStore } from "@/stores/unitOfMeasurmentsStore"
import { getUomName } from "@/utils/uom"

interface PricingTierReadOnlyProps {
  tiers: PriceChangeTier[]
}

const formatPrice = (price: number): string =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(price)

export const PricingTierReadOnly: FC<PricingTierReadOnlyProps> = ({ tiers }) => {
  const { units, getUnits } = useUnitOfMeasurementsStore(
    useShallow((state) => ({ units: state.units, getUnits: state.getUnits }))
  )

  useEffect(() => {
    if (!units.length) getUnits()
  }, [units.length, getUnits])

  if (!tiers.length) return null

  return (
    <Box className='flex flex-col gap-1'>
      {tiers.map((tier) => {
        const uomLabel = getUomName(units, tier.uomId) || tier.uomId.toLowerCase()
        return (
          <Box key={tier.id} className='flex items-center gap-x-8 text-sm'>
            <Typography className='w-20 text-sm text-gray-800'>
              {tier.qty} {uomLabel}
            </Typography>
            <Typography className='text-sm text-gray-800'>{formatPrice(tier.price)} / Pallet</Typography>
          </Box>
        )
      })}
    </Box>
  )
}
